import { useEffect, useState } from 'react';
import blogService from '../../services/blog.service';
import './index.css';

function BlogAd() {
    const [isLoading, setIsLoading] = useState(true);
    const [post, setPost] = useState(null);

    useEffect(() => {
        const loadPost = async () => {
            const response = await blogService.random();

            if (response?.status === 'success' && response?.data) {
                setPost(response.data);
            }

            setIsLoading(false);
        };

        loadPost();
    }, []);

    if (isLoading || !post) {
        return null;
    }

    return (
        <div className="blog-ad">
            <div className="blog-ad__image-wrapper">
                <img
                    className="blog-ad__image"
                    src={post.image}
                    alt={post.title}
                />
            </div>

            <div className="blog-ad__content">
                <span className="blog-ad__label">Blog Simulado Digital</span>

                <h3 className="blog-ad__title">
                    {post.title}
                </h3>

                <p className="blog-ad__description">
                    {post.description}
                </p>

                <a
                    className="blog-ad__button"
                    href={post.url}
                    target="_blank"
                    rel="noreferrer"
                >
                    Continue lendo
                </a>
            </div>
        </div>
    );
}

export default BlogAd;
